import React from 'react';
import type { PensionFund } from '../../types';

export interface PensionFundCommissionProps {
  pensionFund: PensionFund;
  selectedStatus: string;
}

const PensionFundCommission: React.FC<PensionFundCommissionProps> = ({
  pensionFund,
  selectedStatus,
}) => {
  if (selectedStatus !== 'Terminé') return null;

  return (
    <div className="p-4 bg-green-50 rounded-lg border border-green-200">
      <label className="block text-sm font-medium text-gray-700 mb-2">Montant de la commission (CHF) *</label>
      <input
        type="number"
        name="commission_amount"
        step="0.01"
        min="0"
        defaultValue={pensionFund?.commission_amount || ''}
        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none bg-white"
        required
      />
      <p className="text-sm text-gray-600 mt-2">Le statut "Commissionné" sera automatiquement défini sur Oui</p>
    </div>
  );
};

export default PensionFundCommission;
